import React from 'react';
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { capitalizeFirstLetter } from "state/helpers";
import FlexCenter from 'components/FlexCenter';

const WorkloadStatsTable = ({ stats = [] }) => {
  if (!stats || stats.length === 0) {
    return (
      <FlexCenter sx={{ height: '100%', width: '100%' }}>        
        <Typography>Nothing to display</Typography>
      </FlexCenter>
    );
  }
  
  const keys = Object.keys(stats[0] || {}).filter(k => k !== 'group');

  const columns = [
    {
      field: 'group',
      headerName: 'Group',
      flex: 1,
      minWidth: 68,
    },
    ...keys.map(k => ({
      field: k,
      headerName: capitalizeFirstLetter(k),
      flex: 1,
      minWidth: 68,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: (params) => {
        if (typeof params === 'number') {
          // format equityIndex, fairnessIndex thành %
          if (k.includes('Index')) {
            return `${(params * 100).toFixed(1)}%`;
          }
          return params.toFixed(1);
        }
        return params;
      },
    })),
  ];

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={stats.map((row, i) => ({ id: i, ...row }))}
        columns={columns}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
      />
    </Box>
  );
};

export default WorkloadStatsTable;
